module.exports = __webpack_public_path__ + "img/t1.dc6358f6.png";